interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: { to: string; label: string };
  as?: "h2" | "h3";
}

export default function SectionHeading({ eyebrow, title, desc, action, as = "h2" }: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-5 md:mb-7">
      <div className="min-w-0">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-6 h-[2px] rounded-full bg-primary-500" />
            <span className="text-[11px] md:text-xs tracking-[0.2em] uppercase text-primary-600 font-label">
              {eyebrow}
            </span>
          </div>
        )}
        <Heading className="font-heading font-bold text-foreground-950 text-xl md:text-2xl tracking-tight">
          {title}
        </Heading>
        {desc && <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {action && (
        <a
          href={action.to}
          className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer shrink-0"
        >
          {action.label}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm" />
          </span>
        </a>
      )}
    </div>
  );
}